import _ from 'lodash';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectAiUsageState = createSelector(getSystem, ({ aiUsage }) => aiUsage);

export const selectAiUsageGroups = createSelector(selectAiUsageState, ({ groups }) => groups);

export const selectAiUsageSummary = createSelector(selectAiUsageState, ({ summary }) => summary);

export const selectAiUsageItemsForGroup = (state, groupKey) =>
  selectAiUsageState(state).groupItems[groupKey] ?? null;

export const selectAiUsageCalls = (state, metricsId) =>
  selectAiUsageState(state).callsByMetricsId[metricsId] ?? null;

export const selectChatSessionMessages = (state, sessionId) =>
  selectAiUsageState(state).chatMessagesBySessionId[sessionId] ?? null;

export const selectProcessStepInput = (state, stepExecutionId) =>
  selectAiUsageState(state).stepInputByExecId[stepExecutionId] ?? null;

export const selectProcessStepInputFetched = (state, stepExecutionId) =>
  _.has(selectAiUsageState(state).stepInputByExecId, stepExecutionId);

export const selectProcessStepOutput = (state, stepExecutionId) =>
  selectAiUsageState(state).stepOutputByExecId[stepExecutionId] ?? null;

export const selectProcessStepOutputFetched = (state, stepExecutionId) =>
  _.has(selectAiUsageState(state).stepOutputByExecId, stepExecutionId);

export const selectProcessStepError = (state, stepExecutionId) =>
  selectAiUsageState(state).stepErrorByExecId[stepExecutionId] ?? null;

export const selectProcessStepErrorFetched = (state, stepExecutionId) =>
  _.has(selectAiUsageState(state).stepErrorByExecId, stepExecutionId);

export const selectProcessStepSystemPrompt = (state, stepExecutionId) =>
  selectAiUsageState(state).stepSystemPromptByExecId[stepExecutionId] ?? null;

export const selectProcessStepSystemPromptFetched = (state, stepExecutionId) =>
  _.has(selectAiUsageState(state).stepSystemPromptByExecId, stepExecutionId);

export const selectAiStatsCostSeries = createSelector(
  selectAiUsageState,
  ({ stats }) => stats.costSeries,
);

export const selectAiStatsCostLeaderboard = (state, dimension) =>
  selectAiUsageState(state).stats.costLeaderboard[dimension] ?? null;

export const selectAiStatsFeedback = createSelector(
  selectAiUsageState,
  ({ stats }) => stats.feedback,
);
